export default "__VITE_ASSET__DIqZlkJ1__"